import { createSlice } from "@reduxjs/toolkit";

// ✅ Safely parse stored data
const storedAdmin = localStorage.getItem("mcollectagent")
  ? JSON.parse(localStorage.getItem("mcollectagent"))
  : null;

const initialState = {
  isAuthenticated: !!storedAdmin,
  loginData: storedAdmin || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.isAuthenticated = true;
      state.loginData = action.payload;

      // ✅ Store as JSON
      localStorage.setItem("mcollectagent", JSON.stringify(action.payload));
    },

    logout(state) {
      state.isAuthenticated = false;
      state.loginData = null;
      localStorage.removeItem("mcollectagent");
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
